import React from 'react'
import { Col, Row } from 'reactstrap'

const ToxicologyScreening = () => {
  return (
    <div id='website-responsive'>
        <div className='left-padding6rem1 right-padding6rem1 p-top-bottom2rem'>
            <div className=''>
                <div className=''>
                    <text className='fs-ss-30 text-montserrat fw-700 text-ss-primary'>
                        Toxicology Screening 
                    </text>
                    <hr className='hr-style my-md-2' style={{ width:'80px', marginTop:'2px', marginBottom:'4px'}}/>
                </div>

                <div className='pt-md-3 pb-md-4 py-2'>
                    <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        Toxicology screening is a vital process used to assess and evaluate the presence of harmful substances in the body. It involves the analysis of various specimens, such as blood, urine, or hair, to identify and measure the levels of toxic compounds. This screening is crucial in multiple domains, including healthcare, forensic investigations, workplace safety, and environmental assessments. 
                    </text>
                </div>

                <div className='pb-4'>
                    <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        At United Lab Care, we offer comprehensive toxicology screening services designed to provide accurate and reliable results. Our advanced laboratory facilities and experienced professionals ensure that every screening is conducted with precision and attention to detail. 
                    </text>
                </div>

                <div className='pb-4'>
                    <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        One of the most commonly used methods for toxicology screening is urine testing. Urine toxicology tests are non-invasive and have a wide range of applications. They are frequently employed in workplace drug testing programs to detect the presence of drugs or illicit substances in employees. Urine testing is also used in healthcare settings to monitor patients’ medication adherence or to identify potential substance abuse issues. 
                    </text>
                </div>

                <div className='pb-4'>
                    <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        In addition to urine testing, we provide blood toxicology screening. Blood tests are precious for detecting recent drug use, as substances quickly metabolize and can be seen in the bloodstream. Blood toxicology screening is often utilized in emergencies, accident investigations, or when evaluating impaired driving cases. 
                    </text>
                </div>

                <div className=''>
                    <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        A toxicology screen might be finished in light of multiple factors. The test is often ordered to see if someone has taken drugs that could hurt their health. Specialists will play out a toxicology screen on the off chance that they suspect an individual is ingesting illegal medications and that individual is showing the accompanying side effects: 
                    </text>
                </div>

                <div className='pt-md-5 pt-4'>
                    <Row className=''>
                        <Col xs='6' sm='3' md='3' lg='' className='pb-md-3 pb-4 pt-md-0 pt-3'>
                            <div className='flex-center'>
                                <img src='toxicology-testing/Confusion-icon-ULC-Toxicology-Screening.png' alt='' className='' height='auto' width='90px' />
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-700 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>
                                    Confusion
                                </center>
                            </div>
                        </Col>

                        <Col xs='6' sm='3' md='3' lg='' className='pb-md-3 pb-4 pt-md-0 pt-3'>
                            <div className='flex-center'>
                                <img src='toxicology-testing/Deliriousness-icon-ULC-Toxicology-Screening.png' alt='' className='' height='auto' width='90px' />
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-700 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>
                                    Deliriousness
                                </center>
                            </div>
                        </Col>
                        
                        <Col xs='6' sm='3' md='3' lg='' className='pb-md-3 pb-4 pt-md-0 pt-3'>
                            <div className='flex-center'>
                                <img src='toxicology-testing/Unconsciousness-icon-ULC-Toxicology-Screening.png' alt='' className='' height='auto' width='90px' />
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-700 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>
                                    Unconsciousness
                                </center>
                            </div>
                        </Col>
                        <Col xs='6' sm='3' md='3' lg='' className='pb-md-3 pb-4 pt-md-0 pt-3'>
                            <div className='flex-center'>
                                <img src='toxicology-testing/Panic-Attack-icon-ULC-Toxicology-Screening.png' alt='' className='' height='auto' width='90px' />
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-700 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>
                                    Panic Attacks
                                </center>
                            </div>
                        </Col>
                        <Col xs='6' sm='3' md='3' lg='' className='pb-md-3 pb-4 pt-md-0 pt-3'>
                            <div className='flex-center'>
                                <img src='toxicology-testing/Chest-Pain-icon-ULC-Toxicology-Screening.png' alt='' className='' height='auto' width='90px' />
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-700 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>
                                    Chest Pain
                                </center>
                            </div>
                        </Col>
                        <Col xs='6' sm='3' md='3' lg='' className='pb-md-3 pb-4 pt-md-0 pt-3'>
                            <div className='flex-center'>
                                <img src='toxicology-testing/Vomiting-icon-ULC-Toxicology-Screening.png' alt='' className='' height='auto' width='90px' />
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-700 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>
                                    Vomiting
                                </center>
                            </div>
                        </Col>
                        <Col xs='12' sm='3' md='3' lg='' className='pb-md-3 pb-4 pt-md-0 pt-3 '>
                            <div className='flex-center'>
                                <img src='toxicology-testing/Seizures-icon-ULC-Toxicology-Screening.png' alt='' className='' height='auto' width='90px' />
                            </div>
                            <div className='fs-ss-18 text-montserrat fw-700 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                                <center>
                                    Seizures
                                </center>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className='py-4'>
                    <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        Our toxicology screening services are not limited to drugs alone. We also specialize in assessing the presence of environmental toxins and chemicals. These screenings are crucial for evaluating the potential impact of hazardous substances on human health and the environment.  
                    </text>
                </div>

                <div className=''>
                    <text className='fs-ss-16 text-montserrat fw-600 text-ss-black' style={{ letterSpacing:'0.5px'}}>
                        Regarding toxicology screening, trust United Lab Care to be your dedicated partner. Our commitment to accuracy, reliability, and confidentiality sets us apart. Whether you require drug screening, environmental toxin analysis, or workplace safety assessments, our comprehensive toxicology screening services in Chicago are tailored to meet your needs. 
                    </text>
                </div>
            </div>
        </div>
    </div>
  )
}

export default ToxicologyScreening